import templateUrl from "webmodals/prompt.htm";
import open from "webmodals/open";

export default (
  title,
  value,
  {
    size = "md",
    label,
    okButtonLabel = "OK",
    cancelButtonLabel = "Cancel",
    placeholder = label
  } = {}
) =>
  open({
    backdrop: "static",
    templateUrl,
    size,
    bindToController: true,
    controllerAs: "$ctrl",
    controller() {
      this.title = title;
      this.label = label;
      this.placeholder = placeholder;
      this.okButtonLabel = okButtonLabel;
      this.cancelButtonLabel = cancelButtonLabel;
      this.value = value;
    }
  });
